package org.example.project.service

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.contentOrNull
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import org.example.project.manager.LumaticaApiManager

object ScreenConfigApi {
    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun loadScreenConfig(): Map<String, Map<String, String>> {
        val raw = runCatching { LumaticaApiManager.call("screenanzeigemodus/screenconfig") }.getOrDefault("")
        if (raw.isBlank() || raw == "null") return emptyMap()
        return decodeScreenConfig(raw)
    }

    suspend fun saveScreenConfig(config: Map<String, Map<String, String>>): Map<String, Map<String, String>> {
        val raw = runCatching {
            LumaticaApiManager.call("screenanzeigemodus/save-screenconfig/${apiPart(screenConfigPart(config))}")
        }.getOrDefault("")
        if (raw.isBlank() || raw == "null") return config
        return decodeScreenConfig(raw).ifEmpty { config }
    }

    fun version(): Long = GlobalManager.jsonTopicVersion("screenconfig.json")

    fun decodeScreenConfig(raw: String): Map<String, Map<String, String>> =
        runCatching {
            json.parseToJsonElement(raw).jsonObject.mapNotNull { (screenKey, value) ->
                val settings = value as? JsonObject ?: return@mapNotNull null
                screenKey to settings.mapNotNull { (key, settingValue) ->
                    settingValue.jsonPrimitive.contentOrNull?.let { key to it }
                }.toMap()
            }.toMap()
        }.getOrDefault(emptyMap())

    private fun screenConfigPart(config: Map<String, Map<String, String>>): String =
        config.entries.joinToString(";") { (screenKey, settings) ->
            "$screenKey:${settings.entries.joinToString(",") { "${it.key}=${it.value}" }}"
        }

    private fun apiPart(value: String): String =
        js("encodeURIComponent")(if (value.isBlank()) "~" else value) as String
}
